import { Scrollbar } from 'element-ui'

const YScrollbar = Scrollbar
YScrollbar.$depends = [Scrollbar]
YScrollbar.$name = 'y-scrollbar'
YScrollbar._name = 'Scrollbar 滚动条'

export default YScrollbar
